import { render, staticRenderFns } from "./common-training-header.vue?vue&type=template&id=d49ffbd2"
import script from "./common-training-header.vue?vue&type=script&lang=js"
export * from "./common-training-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports